import { SET_PUBLIC_DATA_ASSETS_COUNT, SET_USERS_DASHBOARD_DATA } from "../DataGuard/Utility/DataguardConstant";
import {
  SET_ALL_DATA_TAG_SOURCES,
  SET_DATA_ESTATE,
  SET_DATA_ESTATE_SUMMARY,
  SET_DATA_TAG_ALL_FILES,
  SET_DATA_TAG_DRIVES,
  SET_DATA_TAG_ACCESSIBILITY,
  SET_DATA_TAG_DUPLICATE_FILE_DATA,
  SET_DATA_TAG_FILE_CLASSIFICATIONS,
  SET_DATA_TAG_LOADING,
  SET_DATA_TAG_METADATA,
  SET_DATA_TAG_NODES_DATA,
  SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA,
  SET_DATA_TAG_USERS,
  SET_SELECTED_DATA_TAG_SOURCE_ID,
  SET_TOTAL_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_USERS,
  SET_SIZE_CARD_DATA,
  SET_SENSITIVE_SUMMARY_CARD_DATA,
  SET_CATEGORY_CARD_DATA,
  DATA_ESTATE_SUMMARY_LOADER,
  SET_ALL_FILE_TYPE_LIST,
  SET_DATA_TAG_DUPLICATE_DRIVE_DATA,
  SET_DATA_TAG_DUPLICATE_USER_DATA,
  SET_DATA_TAG_DUPLICATE_USER_DATA_2,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA,
  SET_DATA_TAG_POPUP_LOADER,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2,
  SET_FILE_MAP_DATA,
  SET_USERS_LIST,
  SET_FILES_LIST,
  SET_IS_DATABASE,
  SET_DATA_SOURCES_DATA_TAG
} from "./DataTagConstants";

const initialState = {
  totalFiles: 0,
  dataEstate: [],
  fileClassification: [],
  sensitiveAndRegulated: {},
  duplicateFileData: {},
  metadata: {},
  dataAccessibility: {},
  loading: false,
  nodesData: [],
  allDataSources: [],
  allFiles: {
    content: [],
    totalCount: 0,
  },
  users: {
    content: [],
    totalCount: 0,
  },
  drives: [],
  selectedDataSource: null,
  dataEstateSummary: {},
  searchedListFiles: [],
  searchedDataTagUsers: [],
  sizeCardData: {
    size: 0,
    pda: 0,
    sensitiveData: 0,
    Total: 0
  },
  sensitiveCardData: {
    sensitiveData: [],
    total: 0,
    fileClassificationStatus: []
  }, 
  categoryCardData: [],
  summaryLoader: false,
  fileTypesList: [],
  duplicateDriveData: [],
  duplicateUserData: [],
  duplicateUserData2: [],
  duplicateDriveFileData: [],
  popupLoader: false,
  duplicateFileData2: [],
  fileMapData: [],
  usersList: [],
  filesList: [],
  publicDataAssetsCount: {},
  userDashboardData: {},
  isDatabase: false,
  dataSourcesDataTag: [],
};

export default function dataTagReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOTAL_DATA_TAG_FILES:
      return {
        ...state,
        totalFiles: action.payload,
      };
    case SET_DATA_ESTATE:
      return {
        ...state,
        dataEstate: action.payload,
      };
    case SET_DATA_TAG_FILE_CLASSIFICATIONS: {
      return {
        ...state,
        fileClassification: action.payload,
      };
    }
    case SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA: {
      return {
        ...state,
        sensitiveAndRegulated: action.payload,
      };
    }
    case SET_DATA_TAG_DUPLICATE_FILE_DATA: {
      return {
        ...state,
        duplicateFileData: action.payload,
      };
    }
    case SET_DATA_TAG_METADATA: {
      return {
        ...state,
        metadata: action.payload,
      };
    }
    case SET_DATA_TAG_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_DATA_TAG_NODES_DATA:
      return {
        ...state,
        nodesData: action.payload,
      };
    case SET_DATA_TAG_ALL_FILES:
      return {
        ...state,
        allFiles: action.payload,
      };
    case SET_SELECTED_DATA_TAG_SOURCE_ID:
      return {
        ...state,
        selectedDataSource: action.payload,
      };
    case SET_ALL_DATA_TAG_SOURCES:
      return {
        ...state,
        allDataSources: action.payload,
      };
    case SET_DATA_TAG_USERS:
      return {
        ...state,
        users: action.payload,
      };
    case SET_DATA_ESTATE_SUMMARY:
      return {
        ...state,
        dataEstateSummary: action.payload,
      };
    case SET_DATA_TAG_DRIVES:
      return {
        ...state,
        drives: action.payload,
      };
    case SET_DATA_TAG_ACCESSIBILITY: {
      return {
        ...state,
        dataAccessibility: action.payload,
      };
    };
    case SET_SEARCHED_DATA_TAG_FILES:
      return {
        ...state,
        searchedListFiles: action.payload,
      };
    case SET_SEARCHED_DATA_TAG_USERS:
      return {
        ...state,
        searchedDataTagUsers: action.payload,
      };
    case SET_SIZE_CARD_DATA:
      return {
        ...state,
        sizeCardData: action.payload
      }
    case SET_SENSITIVE_SUMMARY_CARD_DATA:
      return {
        ...state,
        sensitiveCardData: action.payload
      }
    case SET_CATEGORY_CARD_DATA: {
      return {
        ...state,
        categoryCardData: action.payload
      }
    }
    case SET_DATA_SOURCES_DATA_TAG: {
      return {
        ...state,
        dataSourcesDataTag: action.payload
      }
    }
    case DATA_ESTATE_SUMMARY_LOADER: {
      return {
        ...state,
        summaryLoader: action.payload
      }
    }
    case SET_ALL_FILE_TYPE_LIST: {
      return {
        ...state,
        fileTypesList: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_DRIVE_DATA: {
      return {
        ...state,
        duplicateDriveData: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_USER_DATA: {
      return {
        ...state,
        duplicateUserData: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_USER_DATA_2: {
      return {
        ...state,
        duplicateUserData2: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA: {
      return {
        ...state,
        duplicateDriveFileData: action.payload
      }
    }
    case SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2: {
      return {
        ...state,
        duplicateFileData2: action.payload
      }
    }
    case SET_FILE_MAP_DATA: {
      return {
        ...state,
        fileMapData: action.payload
      }
    }
    case SET_USERS_LIST: {
      return {
        ...state,
        usersList: action.payload
      }
    }
    case SET_DATA_TAG_POPUP_LOADER: {
      return {
        ...state,
        popupLoader: action.payload
      }
    }
    case SET_FILES_LIST: {
      return {
        ...state,
        filesList: action.payload
      }
    }
    case SET_PUBLIC_DATA_ASSETS_COUNT: {
      return {
        ...state,
        publicDataAssetsCount: action.payload
      }
    }

    case SET_USERS_DASHBOARD_DATA: {
      return {
        ...state,
        userDashboardData: action.payload
      }
    }
    case SET_IS_DATABASE: {
      return {
        ...state,
        isDatabase: action.payload
      }
    }
    default:
      return state;
  }
}
